import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { tokensAtom } from "../../store";

// This is a simple wrapper around Jotai
// to reduce imports in components. e.g.
//   const [tokens, setTokens] = useTokens();
export const useTokens = () => useAtom(tokensAtom);

export const useTokensValues = () => useAtomValue(tokensAtom);

export const useSetTokens = () => useSetAtom(tokensAtom);
